import React from "react";
import {formatDateCreated} from "../ProactiveMetricsDetailUtil";
import styles from "./styles.module.css"

export default function ProactiveMetricMessageShopify({message, messageAuthor}) {
    return (
        <div className={styles.shopifyMsgContainer}>
            <div className={styles.shopifyMsgContent}>
                <div className={styles.shopifyAuthor}>{messageAuthor}</div>
                <div className={styles.shopifyContentTextStyle}>
                    Converted - {message?.dateConverted ? formatDateCreated(message.dateConverted, 'MMMM D, YYYY') : ''}
                </div>
                <div className={styles.shopifyContentTextStyle}>
                    Order amount - {message?.orderAmountCurrency}{message?.orderAmount}
                </div>
            </div>
        </div>
    )
}